import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Profile from "../screens/auth/Profile";
import Service from "../screens/users/Service";
import Blog from "../screens/users/Blog";
import BlogDetails from "../screens/users/BlogDetails";
import Package from "../screens/users/Package";
import BookInquiry from "../screens/users/BookInquiry";
import InquiryForm from "../screens/auth/InquiryForm";
import Packages from "../screens/auth/Packages";
import Services from "../screens/auth/Services";
import Career from "../screens/users/Career";
import CareerDetail from "../components/UserComponents/career/CareerDetail";
import Category from "../screens/auth/Category";
import SubCategory from "../screens/auth/SubCategory";
import AuthCareer from "../screens/auth/AuthCareer";
import AdminBlog from "../screens/auth/AdminBlog";
import TeamMembers from "../screens/users/TeamMembers";
import Gallery from "../screens/users/Gallery";
import CareerFormDataDetails from "../screens/auth/CareerFormDataDetails";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/inquiry-form",
    component: <InquiryForm />,
  },
  {
    path: "/auth-packages",
    component: <Packages />,
  },
  {
    path: "/auth-category",
    component: <Category />,
  },
  {
    path: "/auth-subcategory",
    component: <SubCategory />,
  },
  {
    path: "/auth-service",
    component: <Services />,
  },
  {
    path: "/auth-blog",
    component: <AdminBlog />,
  },
  {
    path: "/auth-career",
    component: <AuthCareer />,
  },
  {
    path: "/career-form",
    component: <CareerFormDataDetails />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/service/:id",
    component: <Service />,
  },
  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/blog/blog-details/:id",
    component: <BlogDetails />,
  },
  {
    path: "/career",
    component: <Career />,
  },
  // {
  //   path: "/career-detail/:id",
  //   component: <CareerDetail />,
  // },
  {
    path: "/package",
    component: <Package />,
  },
  {
    path: "/book-inquiry",
    component: <BookInquiry />,
  },
  // {
  //   path: "/team-members",
  //   component: <TeamMembers />,
  // },
  {
    path: "/gallery",
    component: <Gallery />,
  },
];
